import { Tooltip} from '@material-ui/core/'
import { withStyles } from "@material-ui/core/styles";

export const CustomTooltip = withStyles((theme) => ({
  tooltip:{
    fontSize: 12
  }
}))(Tooltip);



// WEBPACK FOOTER //
// ./src/components/CustomTooltip.js